/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import loracubeActions from 'loraactions/loracube';
import PageLoading from 'loracoms/PageLoading';

const defaultProps = {
  children: null,
  activated: false,
};

const propTypes = {
  children: React.PropTypes.node,
  activate: React.PropTypes.object.isRequired,
  getActivate: React.PropTypes.func.isRequired,
};

class ActivationLatch extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      activate: props.activate,
    };
  }

  componentWillMount() {
    const { getActivate } = this.props;
    getActivate();
  }

  componentWillReceiveProps(nextProps) {
    const { activate } = nextProps;
    if (activate !== this.props.activate) {
      this.setState({ activate });
    }
  }

  render() {
    const { activate } = this.state;
    if (activate.status !== 'success') {
      return <PageLoading />;
    }

    const protocol = window.location.protocol;
    const hostname = window.location.hostname;

    const { data: { status } } = activate;
    if (status !== 'activated') {
      window.location = `${protocol}//${hostname}:8080`;
      return null;
    }

    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

ActivationLatch.defaultProps = defaultProps;
ActivationLatch.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  activate: state.loracube.getActivate,
  hostname: ownProps.location.hostname,
  location: ownProps.location,
});

const mapDispatchToProps = {
  getActivate: loracubeActions.getActivate,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ActivationLatch);




// WEBPACK FOOTER //
// ./src/containers/ActivationLatch.jsx